import React from 'react';
import { connect } from 'react-redux';
import commonAction from '../../actions/common'
import ScrollBox from '../../components/ScrollBox'
import Lodding from '../../components/Lodding'
import NoData from '../../components/NoData'
import { getSalaryMonthList } from '../../api/Salary'
import { formatSalaryAmount, getSalaryStatusClassName } from '../../libs/salary'
import './index.scss'

class SalaryMonthList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      isCanLoading: true,
      scrollHight: 0,
      animating: false
    }
    this.pageIndex = 1
    this.pageSize = 20
    this.total = 0
  }

  componentDidMount() {
    const pathname = this.props.path;
    this.props.dispatch({ type: commonAction.setPathname, pathname })
    this.props.onRef(this);
    this.handleRefresh()
  }

  getSalaryMonthListFun = async () => {
    this.setState({
      animating: true
    })
    const res = await getSalaryMonthList({
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    })
    if (res.code === 200 && res.data) {
      const list = res.data.list || []
      this.total = res.data.total || 0
      this.setState((state) => ({
        list: state.list.concat(list),
        isCanLoading: true
      }))
    }
    this.setState({
      animating: false
    })
  }

  handleScroll = () => {
    this.setState({
      isCanLoading: false
    })
    if (this.state.list.length < this.total) {
      this.pageIndex += 1
      this.getSalaryMonthListFun()
      return
    }
    this.setState({
      isCanLoading: true
    })
  }

  handleRefresh = () => {
    this.pageIndex = 1
    this.total = 0
    this.setState({
      list: [],
      scrollHight: 0
    }, () => {
      this.getSalaryMonthListFun()
    })
  }

  setScrollHight = (val) => {
    this.setState({
      scrollHight: val
    })
  }

  goDetail = (item) => {
    this.props.history.push({ pathname: `/layout/salary/detail/${item.settlementMonth}` });
  }

  renderIncomeRow(label, value, className = '') {
    return (
      <div className="salaryMonthListBox-item-card-row">
        <span>{label}</span>
        <span className={className}>{formatSalaryAmount(value)}</span>
      </div>
    )
  }

  render() {
    return (
      <div className="salaryMonthListBox commonBodyBox">
        <div className="salaryMonthListBox-scroll">
          {this.state.list.length ? (
            <ScrollBox
              setScrollHight={this.setScrollHight}
              handleRefresh={this.handleRefresh}
              scrollHight={this.state.scrollHight}
              handleScroll={this.handleScroll}
              isCanLoading={this.state.isCanLoading}
            >
              <div className="salaryMonthListBox-list">
                {this.state.list.map((item) => (
                  <div className="salaryMonthListBox-item" key={item.settlementId} onClick={() => this.goDetail(item)}>
                    <div className="salaryMonthListBox-item-card">
                      <div className="salaryMonthListBox-item-card-top">
                        <div>
                          <h3>{item.settlementMonth}</h3>
                          <p>共计 {formatSalaryAmount(item.totalAmount)}</p>
                        </div>
                        <span className={`salaryMonthListBox-status ${getSalaryStatusClassName(item.settlementStatus)}`}>
                          {item.settlementStatusName}
                        </span>
                      </div>
                      {this.renderIncomeRow('维保收入', item.maintenanceIncome)}
                      {this.renderIncomeRow('维修收入', item.repairIncome)}
                      {this.renderIncomeRow('指派收入', item.assignIncome)}
                      {this.renderIncomeRow('指派支出', item.assignExpense, 'is-negative')}
                      {this.renderIncomeRow('维保工单扣款', item.maintenanceDeduction, 'is-negative')}
                    </div>
                  </div>
                ))}
              </div>
            </ScrollBox>
          ) : <NoData />}
        </div>
        <Lodding animating={this.state.animating} />
      </div>
    )
  }
}

export default connect()(SalaryMonthList);
